"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandleNever = exports.HasGreaterThan = exports.Pluralize = exports.ShowReactPromise = exports.Delay = exports.MakePseudoRandomUuidv4 = exports.MakeRandomText = exports.MakePseudoRandomGenerator = exports.AssertNever = void 0;
const ReactDOM = __importStar(require("react-dom"));
function AssertNever(value, type) {
    throw new Error(`Unrecognized value '${value}' for ${type}.`);
}
exports.AssertNever = AssertNever;
function MakePseudoRandomGenerator(seed) {
    return () => {
        const x = Math.sin(seed++) * 10000;
        return x - Math.floor(x);
    };
}
exports.MakePseudoRandomGenerator = MakePseudoRandomGenerator;
function MakeRandomText(length, nextRandom = Math.random) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return [...Array(length)]
        .map(() => characters.charAt(Math.floor(nextRandom() * characters.length)))
        .join("");
}
exports.MakeRandomText = MakeRandomText;
/** See https://stackoverflow.com/a/2117523 */
function MakePseudoRandomUuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
exports.MakePseudoRandomUuidv4 = MakePseudoRandomUuidv4;
function Delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
exports.Delay = Delay;
function ShowReactPromise(createReactElement) {
    const container = document.createElement("div");
    document.body.appendChild(container);
    return new Promise((resolve, reject) => {
        ReactDOM.render(createReactElement(resolve, reject), container);
    })
        .finally(() => {
        ReactDOM.unmountComponentAtNode(container);
        document.body.removeChild(container);
    });
}
exports.ShowReactPromise = ShowReactPromise;
function Pluralize(items, singular, plural) {
    plural = plural || singular + "s";
    return items.length == 1
        ? `1 ${singular}`
        : `${items.length} ${plural}`;
}
exports.Pluralize = Pluralize;
function HasGreaterThan(items, maxCount) {
    var items_1, items_1_1;
    var e_1, _a;
    return __awaiter(this, void 0, void 0, function* () {
        let count = 0;
        try {
            for (items_1 = __asyncValues(items); items_1_1 = yield items_1.next(), !items_1_1.done;) {
                const item = items_1_1.value;
                if (++count > maxCount) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) yield _a.call(items_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    });
}
exports.HasGreaterThan = HasGreaterThan;
function HandleNever(value, label) {
    throw new Error(`Unexpected value for ${label}: ${value}`);
}
exports.HandleNever = HandleNever;
//# sourceMappingURL=utilities.js.map